<template>
  <div
    class="school-id-auth-field max-w-[360px] m-auto mt-8 pt-8 relative min-h-[118px]"
  >
    <div v-if="loading" class="text-center text-gray-500">
      Loading schools...
    </div>
    <div v-else-if="schools && schools.length === 0" class="text-center text-red-500">
      You do not have access to any schools.
    </div>
    <div v-else class="flex flex-col gap-3">
      <div 
        v-for="school in schools" 
        :key="school.uuid"
        @click="selectSchool(school.uuid)"
        class="border rounded px-4 py-3 cursor-pointer hover:bg-blue-50 hover:border-blue-500 transition-colors"
        :class="scId === school.uuid ? 'bg-blue-100 border-blue-500' : 'bg-white border-gray-300'"
      >
        <div class="font-semibold text-gray-800">{{ school.name }}</div>
        <div class="text-sm text-gray-500">{{ school.uuid }}</div>
      </div>
    </div>
    <p v-if="!!errMsg" class="text-red-500 text-xs italic mt-3">
      {{ errMsg }}
    </p>
    <div class="mt-6 text-center">
      <a href="#" @click.prevent="logout" class="text-sm text-gray-500 hover:text-red-500 underline">Logout</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import KeycloakLib from "@/libs/Keycloak";

export default {
  props: ["currentStep"],
  data() {
    return {
      scId: "",
      schools: [],
      loading: true
    };
  },
  computed: {
    errMsg() {
      return this.currentStep.error;
    }
  },
  watch: {
    scId: function(val) {
      this.$emit("can-continue", { value: !!val });
      this.$set(this.currentStep, "scId", this.scId);

      this.currentStep.error && this.$set(this.currentStep, "error", "");
    }
  },
  async mounted() {
    this.$emit("can-continue", { value: false });
    try {
      const res = await this.FetchUserSchools();
      const fetchedSchools = res.data || res;
      const currentDomain = window.location.hostname;
      
      // Lọc ra những trường hợp lệ với domain hiện tại
      if (currentDomain !== 'localhost') {
        this.schools = fetchedSchools.filter(s => {
           // Nếu chưa cấu hình allowed_domain thì vẫn cho hiện tạm, 
           // hoặc nếu cấu hình rồi thì phải khớp domain
           return !s.allowed_domain || currentDomain.includes(s.allowed_domain);
        });
      } else {
        this.schools = fetchedSchools;
      }

      if (this.schools && this.schools.length === 1) {
        this.selectSchool(this.schools[0].uuid);
      } else if (this.schools && this.schools.length === 0 && fetchedSchools.length > 0) {
        // Nếu user có trường nhưng bị lọc hết do sai domain
        this.$set(this.currentStep, "error", `Your account does not have access to this system. Please login at the correct domain!`);
        this.Logout();
      }
    } catch (e) {
      console.error("Error in SchoolAuth:", e);
      if (!this.currentStep.error) {
        this.$set(this.currentStep, "error", "Failed to fetch schools");
      }
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions("schoolAuth", ["FetchUserSchools", "Logout", "SetSchool"]),
    selectSchool(uuid) {
      this.scId = uuid;
      // keep the selected school (with its allowed_domain) for site-based features
      this.SetSchool(this.schools.find(s => s.uuid === uuid) || null);
      setTimeout(() => {
        if (this.scId) {
          this.nextStep();
        }
      }, 300);
    },
    logout() {
      KeycloakLib.doLogout();
      this.Logout();
    }
  },
  inject: ["nextStep"]
};
</script>

<style lang="scss" scoped></style>
